/**
 * Created by Kevin Dench on 6/15/2016.
 */
/* @ngInject */
export default function DefinitionParameterApiService($resource, __env, NumberFormatterService) {
    'use strict';

    function sortNumericParameterValue(parameterValue1, parameterValue2) {
        const numericValue1 = NumberFormatterService.parseFloat(parameterValue1.value);
        const numericValue2 = NumberFormatterService.parseFloat(parameterValue2.value);
        return numericValue1 > numericValue2 ? 1 : numericValue1 === numericValue2 ? 0 : -1;
    }

    function sortStringParameterValue(parameterValue1, parameterValue2) {
        return parameterValue1.value > parameterValue2.value ? 1 : parameterValue1.value === parameterValue2.value ? 0 : -1;
    }

    function areParameterValuesNumeric(parameterValues) {
        for (let i = 0; i < parameterValues.length; ++i) {
            if (!NumberFormatterService.isNumber(parameterValues[i].value)) {
                return false;
            }
        }
        return true;
    }

    return {
        getDefinitionParameters: function (definitionId, callBack, callBackError) {
            $resource(
                `${__env.intellidataApiUrl}definitions/:id/definition-parameters`,
                {id: definitionId}
            ).query(callBack, callBackError);
        },
        getDefinitionParameter: function (definitionId, parameterId, callBack) {
            $resource(
                `${__env.intellidataApiUrl}definitions/:defId/definition-parameters/:paramId`
            ).get(
                {defId: definitionId, paramId: parameterId},
                callBack
            );
        },
        getDefinitionParameterByDefinition: function (definitionId, callBack, callBackError) {
            $resource(
                `${__env.intellidataApiUrl}definitions/:definitionId/definition-parameters`,
                {definitionId: definitionId}
            ).query(callBack, callBackError);
        },
        getDefinitionParameterByDefinitionAndDisplayArea: function (definitionId, displayArea, callBack, callBackError) {
            $resource(
                `${__env.intellidataApiUrl}definitions/:id/definition-parameters`,
                {id: definitionId, displayArea: displayArea}
            ).query(
                function (definitionParameters) {
                    for (var i = 0; i < definitionParameters.length; ++i) {
                        var sortFunction;

                        // Special case. Always use string sort for Chip Size
                        if (definitionParameters[i].parameterId === 58) {
                            sortFunction = sortStringParameterValue;
                        } else {
                            if (areParameterValuesNumeric(definitionParameters[i].parameterValues)) {
                                sortFunction = sortNumericParameterValue;
                            } else {
                                sortFunction = sortStringParameterValue;
                            }
                        }

                        definitionParameters[i].parameterValues.sort(sortFunction);
                    }
                    callBack(definitionParameters);
                }, callBackError);
        },
        getSeries: function (definitionId, callBack, callBackError) {
            $resource(
                `${__env.intellidataApiUrl}definitions/:id/definition-parameters`, {id: definitionId}
            ).query(
                function (definitionParameters) {
                    let series = undefined;
                    for (let i = 0; i < definitionParameters.length; ++i) {
                        if (definitionParameters[i].parameterName === 'Series') {
                            series = definitionParameters[i];
                            break;
                        }
                    }
                    callBack(series);
                },
                callBackError
            );
        }
    };
}
